import { render } from "./customerSourceList.vue?vue&type=template&id=4327715c&scoped=true"
import script from "./customerSourceList.vue?vue&type=script&lang=js"
export * from "./customerSourceList.vue?vue&type=script&lang=js"

import "./customerSourceList.vue?vue&type=style&index=0&id=4327715c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4327715c"]])

export default __exports__